import styled, { css } from 'styled-components';

import { GridCell } from './cell.styled';

export const StyledCell = styled(GridCell)`
  overflow: visible;
  padding: 4px 10px;
  img {
    display: block;
  }
  ${(props) =>
    props.brdColor &&
    css`
      border-color: ${props.brdColor};
    `}
  ${(props) =>
    props.disabled &&
    css`
      cursor: not-allowed;
      img {
        opacity: 0.3;
      }
    `}
`;
